import {
	Avatar,
	Box,
	Icon,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material';
// import whyShareStyles from './WhyShare.styles';
import loginStyles from '../Login/Login.styles';
import finvuLogo from '../../assets/finvuLogoNew.png';
import LockIcon from '@mui/icons-material/Lock';
import { useTranslation } from '../../hooks/useTranslation';

function WhyShare(props) {
	const { t } = useTranslation();
	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<Box sx={loginStyles.footerContainerMobile}>
			<div
				style={{ padding:'1rem', display: 'flex', gap: 8, alignItems: 'center',marginLeft:'auto',marginRight:'auto'}}
			>
				<Avatar
					icon={<LockIcon />}
					variant="square"
					sx={{
						background: 'none',
						height: mobileScreen ? '16px' : '48px',
						width: mobileScreen ? '16px' : '48px',
					}}
				>
					<Icon component={LockIcon} sx={loginStyles.lockIconMobile} />
				</Avatar>
				<Typography
					sx={{
						...loginStyles.footerTextNew,
						color: theme.palette.text,
						fontSize: mobileScreen? '0.7rem' : '1rem',
					}}
				>
					{t('common.messages.secureDataSharing')}
				</Typography>

				<Avatar
					src={finvuLogo}
					sx={{
						width: mobileScreen ? '48px' : '64px',
						'& .MuiAvatar-img': { objectFit: 'contain' },
					}}
				/>
			</div>
		</Box>
	);
}

export default WhyShare;
